<template>
  <div v-if="allMerchantList.length > 1" class="merchant-switch-box">
    <el-popover
      placement="bottom-start"
      trigger="click"
      width="339px"
      popper-class="merchant-switch-popover"
      :visible-arrow="false"
      @hide="hidePopover">
      <div slot="reference" class="switch-btn-box" @click="handleOpen">
        <el-button class="switch-btn" type="primary">
          {{app.userLogin.merchantNo}}
        </el-button>
        <span class="arrow-right">
          <i class="icon-arrow el-icon-arrow-down" :class="[open ? 'is-reverse ' : '']"></i>
        </span>
      </div>
      <div v-loading="dataLoading" class="switch-merchant-list" :class="{'global-merchant': globalMerchant.length > 0}">
        <el-input class="input-merchant-switch" v-model="searchValue" size="small" suffix-icon="el-icon-search" @input="handleSearch"></el-input>
        <div class="merchant-list-wrap margin-top-10">
          <div v-if="globalMerchant.length > 0">
            <div class="merchant-list margin-bottom-10">
              <div
                v-for="item in globalMerchant"
                :key="item.merchantNo"
                class="merchant-item global-merchant-item"
                :class="{active: app.userLogin.merchantNo === item.merchantNo}"
                @click="switchMerchant(item)">
                <div>
                  <p>{{$t('message.user.globalMerchant')}}</p>
                  <p>{{item.merchantNo}}</p>
                </div>
                <el-tooltip v-if="item.auditStatus === 'fail'" :visible-arrow="false" :content="item.auditStatusName" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default" src="@/assets/images/ic-mer-fail.png" @click="noop($event)" />
                </el-tooltip>
                <el-tooltip v-else-if="item.auditStatus === 'processing'" :visible-arrow="false" :content="item.auditStatusName" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default" src="@/assets/images/ic-mer-pending.png" @click="noop($event)" />
                </el-tooltip>
                <span v-else-if="item.defaultAccount"></span>
                <el-tooltip v-else :visible-arrow="false" :content="$t('message.user.setDefaultMerchant')" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default pointer" src="@/assets/images/ic-mer-default1.png" @click="setDefaultAccount(item, $event)" />
                </el-tooltip>
              </div>
            </div>
          </div>
          <div v-if="merchantList1.length > 0">
            <div class="merchant-type">{{$t('message.user.acquiringMerchant')}}</div>
            <div class="merchant-list margin-bottom-10">
              <div
                v-for="item in merchantList1"
                :key="item.merchantNo"
                class="merchant-item"
                :class="{active: app.userLogin.merchantNo === item.merchantNo}"
                @click="switchMerchant(item)">
                <span>{{item.merchantNo}}</span>
                <el-tooltip v-if="item.auditStatus === 'fail'" :visible-arrow="false" :content="item.auditStatusName" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default" src="@/assets/images/ic-mer-fail.png" @click="noop($event)" />
                </el-tooltip>
                <el-tooltip v-else-if="item.auditStatus === 'processing'" :visible-arrow="false" :content="item.auditStatusName" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default" src="@/assets/images/ic-mer-pending.png" @click="noop($event)" />
                </el-tooltip>
                <span v-else-if="item.defaultAccount"></span>
                <el-tooltip v-else :visible-arrow="false" :content="$t('message.user.setDefaultMerchant')" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default pointer" src="@/assets/images/ic-mer-default1.png" @click="setDefaultAccount(item, $event)" />
                </el-tooltip>
              </div>
            </div>
          </div>
          <div v-if="merchantList2.length > 0">
            <div class="merchant-type">{{$t('message.user.payoutMerchant')}}</div>
            <div class="merchant-list">
              <div
                v-for="item in merchantList2"
                :key="item.merchantNo"
                class="merchant-item"
                :class="{active: app.userLogin.merchantNo === item.merchantNo}"
                @click="switchMerchant(item)">
                <span>{{item.merchantNo}}</span>
                <el-tooltip v-if="item.auditStatus === 'fail'" :visible-arrow="false" :content="item.auditStatusName" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default" src="@/assets/images/ic-mer-fail.png" @click="noop($event)" />
                </el-tooltip>
                <el-tooltip v-else-if="item.auditStatus === 'processing'" :visible-arrow="false" :content="item.auditStatusName" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default" src="@/assets/images/ic-mer-pending.png" @click="noop($event)" />
                </el-tooltip>
                <span v-else-if="item.defaultAccount"></span>
                <el-tooltip v-else :visible-arrow="false" :content="$t('message.user.setDefaultMerchant')" placement="right" effect="light" popper-class="merchant-default">
                  <img class="ic-mer-default pointer" src="@/assets/images/ic-mer-default1.png" @click="setDefaultAccount(item, $event)" />
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
    <!-- 暂时不对外开饭注册功能 -->
    <!-- <el-popover width="246px" trigger="click" placement="right" :visible-arrow="false">
      <i slot="reference" class="iconfont icon-zhuce"></i>
      <div class="fast-register-box">
        <p>{{$t('message.user.quickRegistration')}}</p>
        <p class="fast-register-item" @click="handleRegister('1')">{{$t('message.user.acquiringBusiness')}}</p>
        <p class="fast-register-item" @click="handleRegister('0')">{{$t('message.user.collectionsBusiness')}}</p>
      </div>
    </el-popover> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { getMerchantList, switchAccount, setDefaultLoginAccount } from '@/api/common/user';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { setLocalStorage } from '@/utils/tools/utils';

export default {
  computed: {
    ...mapGetters([
      'app',
      'permission',
    ]),
  },
  data() {
    return {
      dataLoading: false,
      open: false,
      searchValue: '',
      globalMerchant: [], // 集团商户
      merchantList1: [], // 收单商户
      merchantList2: [], // 收款商户
      allMerchantList: [], // 所有商户
      auditStatusList: [],
    };
  },
  created() {
    this.initMethod();
  },
  methods: {
    async initMethod() {
      const dict = await GlobalData.getDictList(['AUDIT_STATUS']);
      this.auditStatusList = initSelectedData(dict.AUDIT_STATUS);
      this.fetchMerchantList();
    },
    async fetchMerchantList() {
      const res = await getMerchantList();
      this.allMerchantList = [];
      for (let i = 0; i < res.length; i++) {
        const item = res[i];
        const profile = JSON.parse(item.profile) || {};
        const businessType = `${profile.businessType}`;
        const status = item.status;
        const merchant = {
          userId: item.userId,
          merchantNo: item.merchantNo,
          baseUserOperatorId: item.baseUserOperatorId,
          defaultAccount: item.defaultAccount,
          merchantName: item.merchantName,
          businessType,
          status,
          auditStatus: item.auditStatus,
          auditStatusName: getEnantiomericValue(this.auditStatusList, item.auditStatus),
          merchantType: item.merchantType,
        };
        let showCancellation = false;
        if (item.updateTime) {
          const cancellationTime = new Date(item.updateTime).getTime();
          showCancellation = ((Date.now() - cancellationTime) <= (20 * 24 * 60 * 60 * 1000)); // 注销时间小于等于20天
        }
        if ((businessType === '0' || businessType === '2') && (status === '1' || status === '3' || status === '4' || (status === '2' && (+profile.merchantLogin === 0)))) {
          // 收款商户: 未启用、初始化、启用、禁用（可登录）
          this.allMerchantList.push(merchant);
        } else if (status === '5' || status === '1' || (status === '2' && (+profile.merchantLogin === 0)) || (status === '6' && showCancellation)) {
          // 收单商户: 启用、注销中、禁用（可登录）、已注销（当前时间-注销完成时间<=20天)
          this.allMerchantList.push(merchant);
        }
      }

      this.formatMerchantList(this.searchValue);
    },
    formatMerchantList(filter = '') {
      this.globalMerchant = [];
      this.merchantList1 = [];
      this.merchantList2 = [];
      this.allMerchantList.forEach(item => {
        if (filter && item.merchantNo.indexOf(filter) === -1) {
          // 当不符合筛选时，过滤
          return;
        }
        if (`${item.merchantType}` === '3') {
          this.globalMerchant.push(item);
        } else if (item.businessType === '0' || item.businessType === '2') {
          this.merchantList2.push(item);
        } else {
          this.merchantList1.push(item);
        }
      });
    },
    handleOpen() {
      this.open = !this.open;
    },
    hidePopover() {
      this.open = false;
      this.searchValue = '';
    },
    handleSearch(val) {
      this.formatMerchantList(val);
    },
    handleRegister(type) {
      this.$router.push({ path: '/account/supplement', query: { type: '1', businessType: type } });
    },
    async switchMerchant(merchant) {
      // alert('switchMerchant');
      this.open = false;
      if (merchant.merchantNo === this.app.userLogin.merchantNo) {
        return;
      }
      const loading = this.$loading();
      try {
        const res = await switchAccount({ userId: merchant.userId });
        setLocalStorage('userLogin', JSON.stringify(res));
        setLocalStorage('BusinessTypes', JSON.stringify(res));
        await this.$store.dispatch('app/setUserLogin', res);
        await this.$store.dispatch('app/setBusinessTypes', res);
        await this.$store.dispatch('permission/getMenus', { showLoading: false, refresh: true });
        const menus = this.$store.getters.permission.menus;
        if (menus.length) {
          if (menus[0].menuUrl) {
            window.location.href = menus[0].menuUrl;
          } else if (menus[0].childrenNode) {
            window.location.href = menus[0].childrenNode[0].menuUrl;
          }
        }
      } catch (err) {

      }
      setTimeout(() => {
        loading.close();
      }, 1000);
    },
    setDefaultAccount(merchant, event) {
      event.stopPropagation();
      this.setDefault(merchant.baseUserOperatorId);
    },
    async setDefault(baseUserOperatorId) {
      this.dataLoading = true;
      try {
        await setDefaultLoginAccount(baseUserOperatorId);
        await this.fetchMerchantList();
      } catch (err) {
      }
      this.dataLoading = false;
    },
    noop(e) {
      e.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.merchant-switch-box {
  display: flex;
  align-items: center;
  justify-content: center;

  .switch-btn-box {
    position: relative;
    .switch-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 150px;
      height: 40px;
      border-radius: 4px;
    }
    .arrow-right {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      color: white;
    }
  }

  .icon-zhuce {
    color: $color-primary;
    font-weight: 600;
    font-size: 18px;
    cursor: pointer;
    margin-left: 12px;
  }
}
</style>
<style lang="scss">
@import '~@/styles/variables.scss';

.merchant-switch-popover {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.switch-merchant-list {
  width: 200px;
  box-sizing: border-box;

  &.global-merchant {
    .merchant-type {
      padding-left: 20px;
    }
    .merchant-list .merchant-item {
      padding-left: 30px;
    }
  }

  .input-merchant-switch {
    display: block;
    width: 180px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .merchant-list-wrap {
    max-height: 215px;
    overflow-y: scroll;
  }

  .merchant-type {
    padding-left: 10px;
  }

  .merchant-list {
    .merchant-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 32px;
      cursor: pointer;
      padding-right: 10px;
      padding-left: 20px;
      background: white;
      margin-top: 3px;

      &.global-merchant-item {
        height: 44px;
        line-height: 17px;
        padding-left: 10px;
      }

      &.active, &:hover {
        background: $color-default;
      }

      &.active {
        cursor: not-allowed;
        color: $color-text-default-button;
      }

      .set-default-btn {
        height: 100%;
        cursor: pointer;
        color: $color-text-default-button;
      }

      .icon-a-shanghupiliangruzhubeifen2 {
        color: $color-text-default-button;
      }

      .fail {
        color: $color-danger;
      }

      .ic-mer-default {
        width: 16px;
        height: 16px;
        cursor: default;

        &.pointer {
          cursor: pointer;
        }
      }
    }
  }
}

.fast-register-box {
  // width: 246px;
  box-sizing: border-box;
  color: rgba(0,32,63,0.6);
  line-height: 30px;

  .fast-register-item {
    display: flex;
    align-items: center;
    height: 34px;
    width: 226px;
    background: $color-default;
    cursor: pointer;
    padding-left: 25px;
    color: $color-text-primary;
    line-height: 20px;

    &:hover {
      background: $color-text-primary;
      color: white;
    }
  }
}

.merchant-default {
  &.el-tooltip__popper.is-light {
    border: none;
    box-shadow: 0px 0px 20px 10px rgba(0,0,0,0.05);
    font-size: 14px;
    font-weight: 400;
    color: $color-text-primary;
  }
}
</style>
